import create from 'zustand';
import { UI } from '@root/constant';
import { isInApp } from '@root/shared';

export interface IUi {
  top: number;
  bottom: number;
}

export interface IState {
  ui: IUi;
  loaded: boolean;
  setUi: (v: IUi) => void;
  resetInitData: () => void;
}

let initData = {
  top: 0,
  bottom: 0,
};

if (isInApp) {
  try {
    initData = JSON.parse(window.localStorage.getItem(UI) || '{}');
  } catch (error) {
    initData = {} as IUi;
  }
  if (!Object.keys(initData).length) {
    initData = {
      top: 0,
      bottom: 0,
    };
  }
}

const useUser = create<IState>((set) => ({
  ui: initData,
  loaded: false,
  setUi: (ui: IUi) => {
    return set(() => {
      return {
        ui,
        loaded: true,
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        ui: initData,
        loaded: false,
      };
    });
  },
}));

export default useUser;
